// Canonical membership-tier display names — single source of truth (web).
// The only four valid tiers. Rename here to rebrand a tier app-wide.
// Keep in sync with /app/mobile/src/lib/tiers.ts.
export const TIER_LABELS = {
  free: "Individual Free",
  plus: "Individual Plus",
  business: "Business",
  brand_partner: "Brand Partner",
};
